// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accent-icon-title_wrapper__mj3UF","title":"accent-icon-title_title__B_L0_","icon":"accent-icon-title_icon__FU3ET","image":"accent-icon-title_image__1UXBt"};